import { Component } from '@angular/core';
import { AbstractMenuItem } from '../abstract-menu-item';

@Component({
  selector: 'jnt-sub-menu-item',
  template: ''
})
export class SubMenuItemComponent extends AbstractMenuItem {
}
